
import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import Scroll from '@/components/sroll.vue';
import {fetch,promptMessage} from '@/api/dataHandling.js';
import {urlConfig} from '@/api/urlConfig.js';
import $ from 'jquery';
export default {

data(){
return {
newsListShow:false,
newsList:[],
unreadNum:'',
pageNum:1,
pageSize:5
}
},
components: {
XHeader,Divider,'v-scroll': Scroll
},
methods: {
onRefresh(done) {
this.pageNum++;
if(this.pageNum <this.totalPage){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.getpatientData();
}
done() 

},
getpatientData(){
this.paramsData = {};
this.paramsData.pageNum = this.pageNum;
this.paramsData.pageSize = this.pageSize;
this.paramsData.bizId = this.$route.query.id;
fetch('post',urlConfig.onlineGetpatientNewsurl,this.paramsData).then(response => {
this.totalPage = response.pages;
if(this.pageNum >=this.totalPage){
this.$el.querySelector('.pull-refresh').style.display = 'none';  
}else {
this.$el.querySelector('.pull-refresh').style.display = 'block';  
}
this.unreadNum = response.unreadNum;
if(response.list.length == 0){
this.$store.commit('updateLoadingStatus',{isLoading:false});
return false;
}
for(let j =0;j<response.list.length;j++) {
if(response.list[j].isRead == 1){
response.list[j].isReadTxt = '已读';
}else if(response.list[j].isRead == 2){
response.list[j].isReadTxt = '未读';
}
response.list[j].title = response.list[j].title.split(',');
this.newsList.unshift(response.list[j]);
}
this.newsListShow = true;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}, //获取消息列表
windresize(){
var titletopH = parseInt($('.titletop').css('height'));
$('.content').css('height',(window.innerHeight-titletopH) +'px');
}
},
mounted(){
var _this = this;
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.personId = this.$route.query.personId;
this.getpatientData();
setInterval(function(){
_this.pageNum = 1;
_this.newsList = [];
_this.getpatientData();
},5000);  //五分钟刷新一次
this.windresize();
window.onresize =function(){
_this.windresize();
}
}
}



// WEBPACK FOOTER //
// ./src/project/onlineServicesProject/doctor/patientList.vue